import script from "./docLuBillAddOnFinancialGroups.vue?vue&type=script&setup=true&lang=ts"
export * from "./docLuBillAddOnFinancialGroups.vue?vue&type=script&setup=true&lang=ts"

import "./docLuBillAddOnFinancialGroups.vue?vue&type=style&index=0&id=a270a5a4&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a270a5a4"]])

export default __exports__